import { Division, SocialLink } from '../types';

export const divisions: Division[] = [
  {
    id: 'games',
    title: 'AtomixGame',
    shortName: 'Games & Engines',
    tagline: 'Open-Source Engines & Next-Gen Indie Entertainment',
    description: 'Pioneering open-source 3D/2D game frameworks, high-performance rendering engines (Atom3D, AtomGdx, AtomixGameEngine), and indie titles published on Steam and App Store.',
    icon: 'controller',
    themeColor: '#06d6a0',
    accentGradient: 'linear-gradient(135deg, #0575e6 0%, #00f260 100%)',
    bannerImage: '/images/brand/game-cyberwave.jpg',
    route: '#games',
    githubUrl: 'https://github.com/atomixgame',
    highlights: ['Atom3D & AtomGdx Game Frameworks', 'Steam & App Store Releases', 'Open-Source Shader & ECS Pipelines']
  },
  {
    id: 'musics',
    title: 'AtomixMusics',
    shortName: 'AI Music & Audio',
    tagline: 'Algorithmic Soundscapes & Generative Song Craft',
    description: 'Harnessing generative AI pipelines (inspired by Suno, neural audio modeling, and algorithmic composition) to engineer original songs, emotional beats, and production-ready music tools.',
    icon: 'music-note-beamed',
    themeColor: '#a855f7',
    accentGradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    bannerImage: '/images/brand/atomix-music-banner.jpg',
    route: '#musics',
    highlights: ['Neural Lyric-to-Audio Pipelines', 'Multi-Genre Generative Tracks', 'Algorithmic Beat & Harmony Design']
  },
  {
    id: 'films',
    title: 'AtomixFilms',
    shortName: 'AI Movies & Short Drama',
    tagline: 'Cinematic Storytelling Powered by Generative Vision',
    description: 'Crafting immersive AI-generated cinematic universe films, sci-fi short dramas, viral TikTok series, and next-generation visual effects pipelines for modern digital entertainment.',
    icon: 'film',
    themeColor: '#f97316',
    accentGradient: 'linear-gradient(135deg, #f12711 0%, #f5af19 100%)',
    bannerImage: '/images/brand/film-neon-shadows.jpg',
    route: '#films',
    highlights: ['Cinematic AI Universe Films', 'Viral Short Drama on YouTube & TikTok', 'Automated Storyboarding & Neural VFX']
  },
  {
    id: 'devs',
    title: 'AtomixDevs',
    shortName: 'Vibe Coding & Architecture',
    tagline: 'Deep Tech, Neural Architecture & Fractal Engineering',
    description: 'Empowering builders through "Vibe Coding", deep architectural design patterns, fractal computing, AI workflow orchestration, and articles directly from the founder’s technical archive.',
    icon: 'code-slash',
    themeColor: '#00d2ff',
    accentGradient: 'linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%)',
    bannerImage: '/images/brand/atomix-dev-banner.jpg',
    route: '#devs',
    githubUrl: 'https://atomixnmc.github.io/mydevblog/',
    highlights: ['Vibe Coding Philosophies', 'Fractal & Neural Graph Systems', 'Distributed Game & AI Architecture']
  }
];

export const globalSocialLinks: SocialLink[] = [
  {
    platform: 'github',
    name: 'AtomixGame GitHub',
    url: 'https://github.com/atomixgame',
    icon: 'github'
  },
  {
    platform: 'blog',
    name: 'Dev Blog (mydevblog)',
    url: 'https://atomixnmc.github.io/mydevblog/',
    icon: 'journal-code'
  },
  {
    platform: 'youtube',
    name: 'Atomix YouTube',
    url: 'https://youtube.com/@atomixchannel',
    icon: 'youtube'
  },
  {
    platform: 'tiktok',
    name: 'Atomix TikTok',
    url: 'https://tiktok.com/@atomixchannel',
    icon: 'tiktok'
  },
  {
    platform: 'spotify',
    name: 'Atomix Spotify',
    url: 'https://open.spotify.com/artist/atomixmusic',
    icon: 'spotify'
  }
];
